/* GlobalStyle.jsx */
import { createGlobalStyle} from 'styled-components';
//import { normalize } from "styled-normalize";
import reset from 'styled-reset';
import '../GlobalStyled/font.css'


const GlobalStyle = createGlobalStyle `
${reset} // normalize

* {
    box-sizing:border-box;
}

body {
    background-color: var(--black);
    color: var(--white);
    // no scroll
    ::-webkit-scrollbar { 
    display: none; /* Chrome, Safari, Opera*/
    
    }
}

a {
    text-decoration:none;
    color:inherit;
}

:root {
    font-family: 'Akaya Telivigala', cursive;
    --purple: #8e44ad;
    --grey: #bdc3c7;
    --yellow: #fff200;
    --pink: #ffcccc;
    --orange: #ff9f1a;
    --white: #fff;
    --black: #000;
}
`;

export default GlobalStyle;